import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { quickLinks } from '@/mocks/navigation';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-heart-3-fill text-primary-500 text-2xl"></i>
            </div>
            <span className="font-heading text-lg font-semibold">
              爱情岛导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {quickLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`ml-2 px-4 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50 font-medium'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i
              className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-2">
            {quickLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-4 py-3 text-sm transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-3 text-sm text-primary-600 font-medium hover:bg-primary-50 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}